import { FrankyAnimation } from "types/FrankyAnimation";
import { FrankenstoriesLogo } from "components/FrankenstoriesLogo";
import { useTooltip } from "hooks/useTooltip";

export const Promo = (props: { type?: FrankyAnimation; useMaxWidth?: boolean }) => {
    const { type = "Normal", useMaxWidth = true } = props;

    const { tooltipRef } = useTooltip({ title: "Franky" });

    return (
        <div className="vstack gap-2 text-center" ref={tooltipRef}>
            <h1 className="w-100">
                <FrankenstoriesLogo type={type} useMaxWidth={useMaxWidth} />
            </h1>
        </div>
    );
};
